<script>
import HsScroll from "@/base/hs-scroll/hs-scroll.vue";
import HsTag from "@/base/hs-tag/hs-tag.vue";

export default {
  components: {HsTag, HsScroll},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    datalist: {
      type: Array,
      default() {
        return [
          // TODO: 假数据
          // {
          //   title: '重',
          //   list: [{value: 'chong', select: false}, {value: 'zhong', select: false}]
          // },
        ]
      }
    }
  },
  data() {
    return {
      currentData: []
    }
  },
  computed: {
    currentShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
  },
  watch: {
    show() {
      setTimeout(() => {
        this.initData()
      }, 300)
    }
  },
  methods: {
    initData() {
      this.currentData = (this.datalist || []).map(v => {
        return {
          ...v,
          list: (v.list || []).map(v => {
            return {
              ...v,
              select: false
            }
          })
        }
      })
    },
    select(index, childIndex) {
      this.currentData[index] && this.currentData[index].list &&this.currentData[index].list.map((v, k) => {
        if (k === childIndex) {
          v.select = true
        } else {
          v.select = false
        }
      })
    },
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<template>
  <!--van-dialog 中 better-scroll 无法滚动 添加 lock-scroll false 即可解决-->
  <van-dialog
      v-model="currentShow"
      :title="'选择多音字'"
      :confirm-button-text="$t('Confirm')"
      show-cancel-button
      :cancel-button-text="'手动修改'"
      @confirm="confirm"
      @cancel="cancel"
      :lock-scroll="false"
      close-on-click-overlay
  >
    <div class="content">
      <div class="tips" style="margin-top: -4px;">与证件所示拼音一致</div>
      <hs-scroll class="table-view" :data="currentData">
        <ul>
          <li class="cell" v-for="(item, index) in currentData" :key="index">
            <span class="name">{{item.title}}</span>
            <hs-tag
                v-for="(child, childIndex) in item.list"
                :key="childIndex"
                :title="child.value"
                :active="child.select"
                @click.native="select(index, childIndex)"
            />
          </li>
        </ul>
      </hs-scroll>
    </div>
  </van-dialog>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.content{
  width: 100%;
  .tips{
    @extend .hs-font-body;
    text-align: center;
    margin-bottom: 12px;
    color: $color_black_600;
  }
  .table-view{
    width: 100%;
    max-height: 50vh;
    overflow: hidden;
    position relative
  }
  .cell{
    @extend .flex-center;
    margin-bottom: 8px;
    &:last-child{
      margin-bottom: 0;
    }
    >.name{
      @extend .hs-font-body;
      font-weight: 500;
    }
    .hs-tag{
      @extend .hs-font-caption-1;
      margin-bottom: 0;
      margin-left: 8px;
      &:nth-child(2){
        margin-left: 12px;
      }
    }
  }
}
</style>
